import styled from "styled-components";

import * as Types from "Types";

import AtomRowIcon from "Components/Atoms/RowIcon";
import AtomDescription1 from "Components/Atoms/Description1";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: row;
   align-items: center;
   column-gap: 7px;
   height: 50px;
   ${({ css }) => css}
`;

const RowIcon = styled(AtomRowIcon)``;
const Description1 = styled(AtomDescription1)`
   display: inline-block;
   white-space: nowrap;
   overflow: hidden !important;
   text-overflow: ellipsis;
`;

function Row(props: Types.Default) {
   return <Wrap {...props}></Wrap>;
}

Row.Icon = RowIcon;
Row.Text = Description1;

export default Row;
